import React, { useEffect, useState } from 'react'
import MainSection from '../../Components/MainSection'
import imagePath from '../../constants/imagePath';
import { BtnRightArrow } from '../../constants/svgPath';
import { Link } from 'react-router-dom';
import { getNewsCategories, getNewsPost } from '../../redux/actions/settings';
import ReactPaginate from 'react-paginate';
import { Pagination, Post } from '../../utils/interfaces';
import { API_BASE_URL, WEB_BASE_URL } from '../../config/urls';
import moment from 'moment'
import { useDispatch } from 'react-redux';
import { _setSelectedCurrentNews } from '../../redux/reducers/setting';
import { ShimmerSimpleGallery } from "react-shimmer-effects";


function NewsInsights() {
  const dispatch = useDispatch()
  const [newsServices, setNewsServices] = useState<any[]>([])
  const [selectedPageNumber, setSelectedPageNumber] = useState<number>(0)
  const [newsPostList, setNewsPostList] = useState<Post[]>([])
  const [selectedNewsCategory, setSelectedNewsCategory] = useState<any>({ label: 'All' })
  const [pageData, setPageData] = useState<Pagination>()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getNewsCategories().then((res) => {
      const listData = res?.map((res) => { return ({ label: res?.name, value: res }) })
      setNewsServices([{ label: 'All', value: '' }, ...listData])
    }).catch((error: any) => {

    })
  }, [])

  useEffect(() => {
    const url = `?limit=9&offset=${selectedPageNumber}&category_id=${selectedNewsCategory?.value?.id}`
    setLoading(true)
    getNewsPost(url).then((res) => {
      setLoading(false)
      setNewsPostList(res?.data ?? [])
      setPageData(res?.pagination)

    }).catch((error: any) => {
      setLoading(false)
    })
  }, [selectedPageNumber, selectedNewsCategory])





  // Invoke when user click to request another page.
  const handlePageClick = (event: any) => {
    console.log(event, "eventevent");

    setSelectedPageNumber(pageData?.nextPage ?? event?.selected)
  };






  return (
    <>
      <MainSection title="News & Insights"
        subtitle="Latest Updates & Trends"
        buttons={newsServices}
        selectedSection={selectedNewsCategory}
        onPress={(data: any) => setSelectedNewsCategory(data)} />
      <section className="list_stdy_sec">
        {loading ? <div className="contair "><ShimmerSimpleGallery /></div> :
          newsPostList?.length ? <div className="contair ">
            <div className="news_pg">

              {newsPostList?.map((item, index) => (
                <div key={index} className="check_slider" onClick={() => dispatch(_setSelectedCurrentNews(item))}>
                  <figure className="check_img">
                    <img src={item.featuredImageUrl} alt={item.title} />
                  </figure>
                  <p>{moment(item.created_at).format('MMMM DD , YYYY')}</p>
                  <h3>{item.title}</h3>
                  <div className="check_btn">
                    <Link to={`/news-insights-detail/${item?.slug}`} type="button" className="btn_common btn_primry">Read More<span><BtnRightArrow /></span></Link>
                  </div>

                </div>
              ))}

            </div>
            <ReactPaginate
              breakLabel="..."
              nextLabel="Next »"
              previousLabel="« Previous"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageData?.totalPages ? Number(pageData?.totalPages) + 1 : 1}
              renderOnZeroPageCount={null}
              containerClassName="pagination-container"
              pageClassName="pagination-item"
              pageLinkClassName="pagination-link"
              activeClassName="active"
              previousClassName="pagination-item"
              nextClassName="pagination-item"
              previousLinkClassName="pagination-link"
              nextLinkClassName="pagination-link"
              breakClassName="pagination-item"
              breakLinkClassName="pagination-link"
              forcePage={selectedPageNumber}
            />
          </div> : <div style={{ display: "flex", justifyContent: "center" }}><img style={{ justifyContent: 'center' }} src={imagePath.no_news_found} alt={"no news found"} /></div>
        }

      </section>

    </>
  )
}

export default NewsInsights